// Agent colour map for the Agent Calendar — own localStorage key, kept
// completely separate from the Organization Staff Calendar's
// `staff-color-map` (see CLAUDE.md's load-bearing-modules note and the
// Phase 3 plan's "copy and adapt, don't share"). Shared by AgentCalendar.vue
// (colours the events) and CalendarLeftPanel.vue (colour dots + the edit
// modal), so the storage format only needs validating in one place.
const STORAGE_KEY = 're-agent-color-map';

const FALLBACK_COLOR = '#94a3b8';

const PALETTE = [
  '#3b82f6', // blue
  '#22c55e', // green
  '#f97316', // orange
  '#a855f7', // purple
  '#ec4899', // pink
  '#14b8a6', // teal
  '#eab308', // yellow
  '#ef4444', // red
];

// Wrapped in try/catch per CLAUDE.md's decisions note — localStorage can
// throw (private browsing, quota, disabled storage) and a bad calendar
// colour is never worth crashing the page over.
export function loadAgentColors() {
  try {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      const isValid = Object.values(data).every(
        color => typeof color === 'string' && /^#[0-9A-F]{6}$/i.test(color)
      );
      if (isValid) return data;
    }
    return {};
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to load agent colours:', error);
    return {};
  }
}

export function saveAgentColors(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to save agent colours:', error);
  }
}

export function getAgentColor(map, agentId) {
  return map[String(agentId)] || FALLBACK_COLOR;
}

// Assigns every agent id not already in `map` the next unused palette
// colour (cycling once every id has one), and drops ids no longer in
// `activeAgentIds` — mirrors staffCalendar's syncStaffColors.
export function syncAgentColors(map, activeAgentIds) {
  const next = { ...map };
  activeAgentIds.forEach(id => {
    const key = String(id);
    if (!next[key]) {
      next[key] = PALETTE[Object.keys(next).length % PALETTE.length];
    }
  });
  Object.keys(next).forEach(id => {
    if (!activeAgentIds.map(String).includes(id)) delete next[id];
  });
  return next;
}
